import React, { useEffect } from 'react';
import { useForm } from "react-hook-form";
import MUIModal from '../../common/MUIModal';
import { Grid } from "@mui/material";
import { FormProvider, RHFDateField, RHFTextField } from "../../common/hook-form";
import { LoadingButton } from '@mui/lab';
import { primaryBtnSx } from '../../styles/patterns';

const NprAction = (props) => {
    const { show, handleClose, currentNDRId, isLoadingBtn } = props;

    function convertDate(inputFormat) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(inputFormat)
        return [pad(d.getFullYear()), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
    }

    const onSubmit = (data) => {
        if (data.preferred_date) {
            data.preferred_date = convertDate(data.preferred_date);
        } else {
            data.preferred_date = null;
        }
        props.handleReattemp(data);
    };

    const methods = useForm({})
    const { handleSubmit: handleSubmitForm, reset } = methods

    const hideModal = () => {
        handleClose();
    };

    useEffect(() => {
        if (currentNDRId && currentNDRId.pickup_details) {
            let defaultValues = {
                phone_number: currentNDRId.pickup_details?.from_phone_number,
                drop_pincode: currentNDRId.pickup_details?.from_pincode,
                address: currentNDRId.pickup_details?.from_address,
                awb: currentNDRId.awb_number,
                preferred_date: null
            };
            reset({ ...defaultValues });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentNDRId]);


    return (
        <MUIModal open={show} handleClose={hideModal} title={`Reattempt Action / ${currentNDRId.awb_number}`}>
            <Grid container spacing={5}>
                <Grid item xs={12}>
                    <FormProvider
                        methods={methods}
                        onSubmit={handleSubmitForm(onSubmit)}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <RHFTextField multiline disabled name="awb" label="AWB" size="small" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField multiline name="address" label="Address" size="small" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="landmark" label="Landmark" size="small" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="drop_pincode" label="Pincode" size="small" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="phone_number" label="Phone Number" size="small" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFDateField name="preferred_date" disablePast label="Preferred Date" size="small" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField multiline name="comment" label="Remark" size="small" />
                            </Grid>
                            <Grid item xs={3} md={8} sx={{ mt: 2 }}>
                                <LoadingButton
                                    loading={isLoadingBtn}
                                    type="submit"
                                    variant="contained"
                                    size="small"
                                    sx={primaryBtnSx}
                                >
                                    Submit
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>
            </Grid>

        </MUIModal>
    );
};
export default NprAction;
